import type { DraftInput } from '../../../../shared/drafts';
import { STATION_RUN_RULES } from '../../../../shared/stationRunRules';
function question(level: number): DraftInput['questions'][number] {
  return { prompt: `${level}. istasyon sorusu`, levels: [level], timeLimitSeconds: null,
    choices: [{ text: 'Doğru cevap', isCorrect: true }, { text: 'Yanlış cevap 1', isCorrect: false }, { text: 'Yanlış cevap 2', isCorrect: false }] };
}
export function createStationRunDraft(): DraftInput {
  return { title: 'Yeni İstasyon Koşusu', templateKey: 'station-run', levelMode: 'manual', maxLevels: 5, trackTime: true,
    timingMode: 'none', questions: Array.from({ length: 5 }, (_, i) => question(i + 1)) };
}
export function resizeStationRunDraft(draft: DraftInput, count: number): DraftInput {
  const maxLevels = Math.max(STATION_RUN_RULES.minQuestions, Math.min(STATION_RUN_RULES.maxQuestions, Math.trunc(count)));
  return { ...draft, timingMode: 'none', trackTime: true, maxLevels, questions: Array.from({ length: maxLevels }, (_, i) =>
    ({ ...(draft.questions.find((q) => q.levels[0] === i + 1) ?? question(i + 1)), levels: [i + 1], timeLimitSeconds: null })) };
}
